import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, ListItem, Typography, Button, Tooltip } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { usePopupState, bindToggle } from 'material-ui-popup-state/hooks';
import { useTranslate, useDataProvider } from 'react-admin';
import { DeleteOutline, Clear } from '@material-ui/icons';
import SortableHeader from '../header-sortable';
import Checkbox from '../../checkbox';
import { ThreeDotsButton } from '../button';
import Loading from '../loading';
import ListPopover from '../list-item-popover';
import ListPopoverItem from '../list-item-popover/item';
import Snackbar from '../snackbar';
import { useHistory } from 'react-router';
import Zoom from '@material-ui/core/Zoom';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        marginTop: theme.spacing(1),
        height: 50
    },
    checkbox: {
        color: theme.palette.common.white
    },
    delete: {
        fontSize: 13,
        fontFamily: 'UniviaPro',
        fontWeight: 'normal',
        letterSpacing: '0.13px',
        lineHeight: '16.3px',
    },
    bodyItem: {
        color: "#88898c",
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: 0,
        marginTop: theme.spacing(1)
    },
    bodyColumnItem: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    boldText: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 14,
        fontWeight: '500',
        color: '#237fc2',
        letterSpacing: 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

    },
    normalText: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',

    },
    normalTextOffline: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#e1503a',
        whiteSpace: 'nowrap',

    },
    normalTextOnline: {
        fontSize: 13,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: '#bbd593',
        whiteSpace: 'nowrap',
    },
    iconPopover: {
        minWidth: 30,
    },
    titlePopover: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
    },
}));

const StyledButton = withStyles(theme => ({
    root: {
        background: 'transparent',
        marginRight: theme.spacing(4),
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#ffffff',
    },
    label: {
        textTransform: 'capitalize',
        fontWeight: 'normal',
        marginLeft: theme.spacing(1),
        alignItems: 'flex-end'
    },
}))(Button);

const CustomTooltip = withStyles((theme) => ({

    arrow: {
        fontSize: 8,
    }
}))(Tooltip);
function TableCustomize(props) {
    const { config, data, loading, onCheck, onCheckAll, onSort, onAction, tableDelete, headerButtons, noDataLabel, disableClick } = props;
    const { headers, popupBodies } = config;
    const { bodies, sortable } = data;
    const { getList, setList, urlDelete } = tableDelete || {};
    const history = useHistory()
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const popupState = usePopupState({ variant: 'popper', popupId: 'list-item-popover' });
    const [activeIdx, setActiveIdx] = useState(-1);
    const [timeoutDelete, setTimeoutDelete] = useState({
        timeoutId: null,
        ids: []
    });

    const isCheckedAll = () => {
        if (bodies.length === 0) return false;
        if (bodies.filter(item => item.checked).length < bodies.length) return false;
        return true;
    }

    const getListItemSelected = () => {
        return bodies.filter(item => item.checked);
    }

    const checkListUniqueProfile = () => {
        const listItem = bodies.filter(item => item.checked);
        let result = true
        listItem.forEach(item => {
            if (listItem[0].profile !== item.profile) {
                result = false;
            }
        })
        return result;
    }

    const onActionClick = (event, index) => {
        setActiveIdx(index);
        bindToggle(popupState).onClick(event);
    }

    const onDelete = (ids = []) => {
        const newList = bodies.filter(item => ids.indexOf(item.id) === -1);
        setList({
            sortable: sortable,
            bodies: newList
        });

        if (timeoutDelete.timeoutId) {
            executeDelete(timeoutDelete.ids);
            clearTimeout(timeoutDelete.timeoutId);
        }

        const timeoutId = setTimeout(() => {
            executeDelete(ids);
        }, 4000);
        setTimeoutDelete({ timeoutId, ids });
    }

    const onUndoDelete = () => {
        setTimeoutDelete({ timeoutId: null, ids: [] });
        getList();
        clearTimeout(timeoutDelete.timeoutId);
    }

    const executeDelete = (ids) => {
        setTimeoutDelete({
            timeoutId: null,
            ids: []
        });
        ids.forEach(id => {
            dataProvider('DELETE', urlDelete, { id }).then(() => {
            }).catch(error => console.error('DELETE TABLE ITEMS ERROR:', error));
        });
    }

    const onClear = () => {
        const newList = bodies.map(item => {
            item.checked = false;
            return item;
        });
        setList({
            sortable: sortable,
            bodies: newList
        });
    }

    const handleDeleteMulti = () => {
        const ids = getListItemSelected().map(item => item.id);
        onDelete(ids);
    }

    const onHeaderButtonClick = (item) => {
        if (item.isDelete) {
            handleDeleteMulti();
        } else {
            item.action();
        }
    }

    const getTextClasses = (header, item) => {
        if (header.bold) return classes.boldText;
        if (header.configColor) {
            if (item.green) return classes.normalTextOnline;
            if (item.red) return classes.normalTextOffline;
        }
        return classes.normalText;
    }

    useEffect(() => {
        // Inactive button
        if (!popupState.isOpen) {
            setActiveIdx(-1);
        }


    }, [popupState])
    return (
        <Box>
            {/* HEADERS */}
            <Snackbar
                show={timeoutDelete.timeoutId !== null}
                message={translate('pos.common.deleted')}
                undo={onUndoDelete}
                onClose={() => setTimeoutDelete({ timeoutId: null, ids: [] })}
            />

            {
                headerButtons && getListItemSelected().length > 0 ? (
                    // Header selected
                    <Box display="flex" mt={1} py={1} bgcolor='#56657f'>
                        <Box display="flex" alignItems='center' justifyContent='center' px={1}>
                            <Checkbox className={classes.checkbox} checked={isCheckedAll()} onClick={() => onCheckAll(isCheckedAll())} />
                            {
                                headerButtons.map((item, index) => (
                                    <Box key={index} hidden={(item.label === translate('pos.devices.assign') && getListItemSelected().length > 6)
                                        || (item.label === translate('pos.devices.firmwareUpdate') && checkListUniqueProfile() === false)}>
                                        <StyledButton
                                            key={item.id}
                                            onClick={() => onHeaderButtonClick(item)}
                                            variant='text'
                                            startIcon={item.icon}
                                        >{item.label}</StyledButton>
                                    </Box>
                                ))
                            }
                        </Box>
                        <Box marginLeft="auto" pt={0.5}>
                            <StyledButton
                                onClick={onClear}
                                variant='text'
                                startIcon={<Clear />}
                            >{getListItemSelected().length} {getListItemSelected().length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                        </Box>
                    </Box>
                    // END Header selected
                ) : (
                        <ListItem className={classes.header}>
                            {
                                popupBodies ?
                                    <Box flex={0.5} px={1}>
                                        {onCheckAll && popupBodies.filter(action => !action.hidden).length > 0 && <Checkbox className={classes.checkbox} checked={isCheckedAll()} onClick={() => onCheckAll(isCheckedAll())} />}
                                    </Box> :
                                    <Box flex={0.5} px={1}>
                                        {onCheckAll && <Checkbox className={classes.checkbox} checked={isCheckedAll()} onClick={() => onCheckAll(isCheckedAll())} />}
                                    </Box>
                            }
                            {
                                headers.map(header => (
                                    <Box mr={2} flex={header.width} key={header.field}>
                                        <SortableHeader title={translate(header.label)} field={header.field} order={sortable} setOrder={onSort} hiddenIconSort={header.hiddenSort} />
                                    </Box>
                                ))
                            }
                            {/* {hasEndIcon && <Box flex={0.5} />} */}
                        </ListItem>
                    )
            }
            {/* END HEADERS */}

            <Loading show={loading} />

            {/* BODIES */}
            {
                (!loading && bodies.length === 0) && (
                    <Box display='flex' mt={2} justifyContent='center'>
                        <Typography>{noDataLabel}</Typography>
                    </Box>
                )
            }
            {
                (!loading && bodies.length > 0) && bodies.map((item, index) => (
                    <Box position="relative" key={item.id + ''}>
                        {
                            disableClick ? <ListItem className={classes.bodyItem}>
                                <Box flex={0.5} className={classes.childItem} px={1}>
                                    {
                                        popupBodies ?
                                            ((popupBodies.filter(action => !action.hidden).length > 0) &&
                                                <Checkbox
                                                    onClick={(event) => {
                                                        event.stopPropagation()
                                                        onCheck(item)
                                                    }}
                                                    checked={item.checked}
                                                />) :
                                            (
                                                <Checkbox
                                                    onClick={(event) => {
                                                        event.stopPropagation()
                                                        onCheck(item)
                                                    }}
                                                    checked={item.checked}
                                                />
                                            )
                                    }
                                </Box>
                                {
                                    headers.map((header) => {
                                        if (header.hiddenTooltip) {
                                            return <Box mr={2} flex={header.width} className={classes.bodyColumnItem} key={item.id + '_' + header.field}>
                                                <CustomTooltip arrow TransitionComponent={Zoom} placement="left-start" title={
                                                    <Box>
                                                        <Typography style={{ lineHeight: 1.6, fontSize: 12, fontFamily: 'UniviaPro' }}>{item.roomCluster}</Typography>
                                                    </Box>}
                                                >
                                                    <Typography style={{ width: 100 }} className={getTextClasses(header, item)}>{item.room}</Typography>
                                                </CustomTooltip>
                                            </Box>
                                        }
                                        else {
                                            return <Box mr={2} flex={header.width} className={classes.bodyColumnItem} key={item.id + '_' + header.field}>
                                                <Typography className={getTextClasses(header, item)}>{item[header.field]}</Typography>
                                            </Box>
                                        }
                                    })
                                }
                            </ListItem> :
                                <ListItem className={classes.bodyItem} button onClick={props.path ? () => { history.push(`/${props.path}/${item.id}`) } : () => { }}>
                                    <Box flex={0.5} className={classes.childItem} px={1}>
                                        {
                                            popupBodies ?
                                                ((popupBodies.filter(action => !action.hidden).length > 0) &&
                                                    <Checkbox
                                                        onClick={(event) => {
                                                            event.stopPropagation()
                                                            onCheck(item)
                                                        }}
                                                        checked={item.checked}
                                                    />) :
                                                (
                                                    <Checkbox
                                                        onClick={(event) => {
                                                            event.stopPropagation()
                                                            onCheck(item)
                                                        }}
                                                        checked={item.checked}
                                                    />
                                                )
                                        }
                                    </Box>
                                    {
                                        headers.map((header) => {
                                            if (header.hiddenTooltip) {
                                                return <Box mr={2} flex={header.width} className={classes.bodyColumnItem} key={item.id + '_' + header.field}>
                                                    <CustomTooltip arrow TransitionComponent={Zoom} placement="left-start" title={
                                                        <Box>
                                                            <Typography style={{ lineHeight: 1.6, fontSize: 12, fontFamily: 'UniviaPro' }}>{item.roomCluster}</Typography>
                                                        </Box>}
                                                    >
                                                        <Typography style={{ width: 100 }} className={getTextClasses(header, item)}>{item.room}</Typography>
                                                    </CustomTooltip>
                                                </Box>
                                            }
                                            else {
                                                return <Box mr={2} flex={header.width} className={classes.bodyColumnItem} key={item.id + '_' + header.field}>
                                                    <Typography className={getTextClasses(header, item)}>{item[header.field]}</Typography>
                                                </Box>
                                            }
                                        })
                                    }
                                </ListItem>
                        }

                        {
                            (popupBodies && popupBodies.filter(action => !action.hidden).length > 0 && getListItemSelected().length === 0) && (
                                <ThreeDotsButton
                                    active={activeIdx === index}
                                    onClick={(event) => onActionClick(event, index)}
                                />
                            )
                        }
                    </Box>
                ))
            }
            {/* END BODIES */}

            {/* EDIT-DELETE ITEM POPUP */}
            {
                popupBodies && popupBodies.filter(action => !action.hidden).length > 0 && (
                    <ListPopover popupState={popupState}>
                        {
                            popupBodies.filter(action => !action.hidden).map(action => (
                                <ListPopoverItem
                                    key={'list-item' + action.id}
                                    label={translate(action.label)}
                                    icon={action.icon}
                                    onClick={() => {
                                        popupState.close();
                                        if (action.isDelete) {
                                            onDelete([bodies[activeIdx].id]);
                                        } else {
                                            onAction(bodies[activeIdx], action.id);
                                        }
                                    }}
                                />
                            ))
                        }
                    </ListPopover>
                )
            }
            {/* END EDIT-DELETE ITEM POPUP */}
        </Box >
    )
}

TableCustomize.propTypes = {
    config: PropTypes.shape({
        headers: PropTypes.array.isRequired,
        popupBodies: PropTypes.array,
    }),
    data: PropTypes.shape({
        bodies: PropTypes.array.isRequired,
        sortable: PropTypes.shape({
            field: PropTypes.string.isRequired,
            order: PropTypes.string.isRequired,
        }),
    }),
    onCheck: PropTypes.func.isRequired,
    onCheckAll: PropTypes.func,
    onSort: PropTypes.func.isRequired,
    onAction: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    noDataLabel: PropTypes.string,

    // For delete
    tableDelete: PropTypes.shape({
        getList: PropTypes.func.isRequired,
        setList: PropTypes.func.isRequired,
        urlDelete: PropTypes.string.isRequired
    }),
    headerButtons: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.object.isRequired,
            action: PropTypes.func,
            isDelete: PropTypes.bool,
        })
    )
};


TableCustomize.defaultProps = {
    noDataLabel: '',
};

export default TableCustomize;
export { StyledButton }
